import AppRouter from "./router/AppRouter";
import "./App.css";
import "./typography.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

type AppProps = {
  location?: string;
};

function App({ location }: AppProps) {
  return (
    <div className="App">
      <AppRouter location={location} />
    </div>
  );
}

export default App;
